{
	"Features For Page": {
		"Feature 01 Location Map": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"fieldMap.iframeSrc": {
					"translations": {},
					"value": "mapSrc"
				},
				"fieldMap.title": {
					"translations": {},
					"value": "label"
				}
			}
		},
		"Feature 02 Services": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"componentId": {
					"translations": {},
					"value": "Features For Page Location Services"
				}
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "py-24 my-0"
				},
				"featureClass": {
					"translations": {},
					"value": "h-full"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "w-full"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-4"
				},
				"iconClass": {
					"translations": {},
					"value": "m-2 sm:m-4"
				},
				"iframeClass": {
					"translations": {},
					"value": "w-full h-full"
				}
			}
		},
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "locations"
		},
		"hideTitles": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "true"
		},
		"index": 0,
		"pageOrder": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "03"
		}
	},
	"Features For Page Location Services": {
		"Feature 01 Address": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"fieldMap.featureContent": {
					"translations": {
						"ar": "العنوان المنسق",
						"en": "formattedAddress",
						"en-GB": "formattedAddress",
						"en-US": "formattedAddress",
						"es": "dirección formateada",
						"es-419": "dirección formateada",
						"es-ES": "dirección formateada",
						"he": "כתובת מעוצבת",
						"it": "Indirizzo formattato",
						"pl": "sformatowanyAdres",
						"sw": "Anwani iliyopangwa",
						"tl": "naka-format na Address",
						"vi": "Địa chỉ được định dạng",
						"zh": "格式化地址"
					},
					"value": "formattedAddress"
				},
				"title": {
					"translations": {
						"ar": "عنوان",
						"en": "Address",
						"en-GB": "Address",
						"en-US": "Address",
						"es": "DIRECCIÓN",
						"es-419": "DIRECCIÓN",
						"es-ES": "DIRECCIÓN",
						"he": "כְּתוֹבֶת",
						"it": "Indirizzo",
						"pl": "Adres",
						"sw": "Anwani",
						"tl": "Tirahan",
						"vi": "Địa chỉ",
						"zh": "地址"
					},
					"value": "Address"
				}
			}
		},
		"Feature 01 Address Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"address-card\",\"icon\":[576,512,[62140,\"contact-card\",\"vcard\"],\"f2bb\",\"M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 256l64 0c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16L80 384c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80zm-24-96a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm240-48l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z\"]}",
				"name": "faAddressCard"
			}
		},
		"Feature 02 Phone": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"fieldMap.featureContent": {
					"translations": {
						"ar": "Location.value.response-nationalPhoneNumber",
						"en": "Location.value.response-nationalPhoneNumber",
						"en-GB": "Location.value.response-nationalPhoneNumber",
						"en-US": "Location.value.response-nationalPhoneNumber",
						"es": "Ubicación.valor.respuesta-númeroteléfononacional",
						"es-419": "Ubicación.valor.respuesta-númeroteléfononacional",
						"es-ES": "Ubicación.valor.respuesta-númeroteléfononacional",
						"he": "מספר טלפון לאומי (Location.value.response-national)",
						"it": "Posizione.valore.risposta-numero di telefono nazionale",
						"pl": "Lokalizacja.wartość.odpowiedź-krajowyNumerTelefonu",
						"sw": "Nambari ya Simu ya Eneo.thamani.jibu-national",
						"tl": "Lokasyon.halaga.tugon-pambansaNumero ng Telepono",
						"vi": "Vị trí.giá trị.phản hồi-số điện thoại quốc gia",
						"zh": "Location.value.response-nationalPhoneNumber"
					},
					"value": "Location.value.response-nationalPhoneNumber"
				},
				"title": {
					"translations": {
						"ar": "الهاتف",
						"en": "Telephone",
						"en-GB": "Telephone",
						"en-US": "Telephone",
						"es": "Teléfono",
						"es-419": "Teléfono",
						"es-ES": "Teléfono",
						"he": "טֵלֵפוֹן",
						"it": "Telefono",
						"pl": "Telefon",
						"sw": "Simu",
						"tl": "Telepono",
						"vi": "Điện thoại",
						"zh": "电话"
					},
					"value": "Telephone"
				}
			}
		},
		"Feature 02 Phone Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"phone\",\"icon\":[512,512,[128222,128379],\"f095\",\"M160.2 25C152.3 6.1 131.7-3.9 112.1 1.4l-5.5 1.5c-64.6 17.6-119.8 80.2-103.7 156.4 37.1 175 174.8 312.7 349.8 349.8 76.3 16.2 138.8-39.1 156.4-103.7l1.5-5.5c5.4-19.7-4.7-40.3-23.5-48.1l-97.3-40.5c-16.5-6.9-35.6-2.1-47 11.8l-38.6 47.2C233.9 335.4 177.3 277 144.8 205.3L189 169.3c13.9-11.3 18.6-30.4 11.8-47L160.2 25z\"]}",
				"name": "faPhone"
			}
		},
		"Feature 03 Hours": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"fieldMap.featureContent": {
					"translations": {
						"ar": "ساعات مبسطة",
						"en": "hoursSimplified",
						"en-GB": "hoursSimplified",
						"en-US": "hoursSimplified",
						"es": "horasSimplificado",
						"es-419": "horasSimplificado",
						"es-ES": "horasSimplificado",
						"he": "שעותפשוט",
						"it": "oreSemplificate",
						"pl": "godzinyUproszczone",
						"sw": "saaIliyorahisishwa",
						"tl": "orasPinasimple",
						"vi": "giờ đơn giản",
						"zh": "小时简化"
					},
					"value": "hoursSimplified"
				},
				"title": {
					"translations": {
						"ar": "ساعات",
						"en": "Hours",
						"en-GB": "Hours",
						"en-US": "Hours",
						"es": "Horas",
						"es-419": "Horas",
						"es-ES": "Horas",
						"he": "שעות",
						"it": "Ore",
						"pl": "Godziny",
						"sw": "Saa za kazi",
						"tl": "Mga Oras",
						"vi": "Giờ",
						"zh": "小时"
					},
					"value": "Hours"
				}
			}
		},
		"Feature 03 Hours Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"clock\",\"icon\":[512,512,[128339,\"clock-four\"],\"f017\",\"M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z\"]}",
				"name": "faClock"
			}
		},
		"Feature 04 Video": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"fieldMap.featureContent": {
					"translations": {
						"ar": "ساعات من الفيديو",
						"en": "hoursVideo",
						"en-GB": "hoursVideo",
						"en-US": "hoursVideo",
						"es": "horasVideo",
						"es-419": "horasVideo",
						"es-ES": "horasVideo",
						"he": "שעותוידאו",
						"it": "oreVideo",
						"pl": "godzinyWideo",
						"sw": "saaVideo",
						"tl": "orasVideo",
						"vi": "giờVideo",
						"zh": "视频"
					},
					"value": "hoursVideo"
				},
				"title": {
					"translations": {
						"ar": "فيديو",
						"en": "Video",
						"en-GB": "Video",
						"en-US": "Video",
						"es": "Video",
						"es-419": "Video",
						"es-ES": "Video",
						"he": "וִידֵאוֹ",
						"it": "Video",
						"pl": "Wideo",
						"sw": "Video",
						"tl": "Bidyo",
						"vi": "Băng hình",
						"zh": "视频"
					},
					"value": "Video"
				}
			}
		},
		"Feature 04 Video Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"video\",\"icon\":[576,512,[\"video-camera\"],\"f03d\",\"M96 64c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L96 64zM464 336l73.5 58.8c4.2 3.4 9.4 5.2 14.8 5.2 13.1 0 23.7-10.6 23.7-23.7l0-240.6c0-13.1-10.6-23.7-23.7-23.7-5.4 0-10.6 1.8-14.8 5.2L464 176 464 336z\"]}",
				"name": "faVideo"
			}
		},
		"Feature 05 In Person": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"fieldMap.featureContent": {
					"translations": {
						"ar": "ساعات الحضور الشخصي",
						"en": "hoursInPerson",
						"en-GB": "hoursInPerson",
						"en-US": "hoursInPerson",
						"es": "horas en persona",
						"es-419": "horas en persona",
						"es-ES": "horas en persona",
						"he": "שעות באופן אישי",
						"it": "ore di persona",
						"pl": "godzinyOsobiście",
						"sw": "hoursInPerson",
						"tl": "orasSa Tao",
						"vi": "giờ Trực tiếp",
						"zh": "亲自"
					},
					"value": "hoursInPerson"
				},
				"title": {
					"translations": {
						"ar": "شخصياً",
						"en": "In Person",
						"en-GB": "In Person",
						"en-US": "In Person",
						"es": "En persona",
						"es-419": "En persona",
						"es-ES": "En persona",
						"he": "באופן אישי",
						"it": "Di persona",
						"pl": "Osobiście",
						"sw": "Binafsi",
						"tl": "Nang Personal",
						"vi": "Trực tiếp",
						"zh": "亲自"
					},
					"value": "In Person"
				}
			}
		},
		"Feature 05 In Person Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"people-arrows\",\"icon\":[512,512,[\"people-arrows-left-right\"],\"e068\",\"M32 64A64 64 0 1 1 160 64 64 64 0 1 1 32 64zM0 224c0-35.3 28.7-64 64-64l64 0c3.2 0 6.4 .2 9.5 .7L93.1 205.1C65 233.2 65 278.8 93.1 306.9l56 56c3.4 3.4 7 6.4 10.9 9l0 92.1c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-120.6C12.9 332.4 0 311.7 0 288l0-64zM352 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm66.9 141.1l-44.4-44.4c3.1-.5 6.3-.7 9.5-.7l64 0c35.3 0 64 28.7 64 64l0 64c0 23.7-12.9 44.4-32 55.4L480 464c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-92.1c3.9-2.6 7.5-5.6 10.9-9l56-56c28.1-28.1 28.1-73.7 0-101.8zM302.8 177.8c9-3.7 19.3-1.7 26.2 5.2l56 56c9.4 9.4 9.4 24.6 0 33.9l-56 56c-6.9 6.9-17.2 8.9-26.2 5.2S288 321.7 288 312l0-24-64 0 0 24c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-56-56c-9.4-9.4-9.4-24.6 0-33.9l56-56c6.9-6.9 17.2-8.9 26.2-5.2S224 190.3 224 200l0 24 64 0 0-24c0-9.7 5.8-18.5 14.8-22.2z\"]}",
				"name": "faPeopleArrows"
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureClass": {
					"translations": {},
					"value": "grid grid-cols-[auto_1fr] gap-x-2 sm:gap-x-4"
				},
				"featureContentClass": {
					"translations": {},
					"value": "col-start-2"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 gap-2 sm:gap-4"
				}
			}
		},
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "locations"
		},
		"iconSize": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "2x"
		},
		"index": 1
	},
	"Features Location Grid": {
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "py-24 my-0"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "mx-auto text-center"
				},
				"featureTitleClass": {
					"translations": {},
					"value": "text-3xl"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 md:grid-cols-2"
				},
				"iconClass": {
					"translations": {},
					"value": "mx-auto"
				}
			}
		},
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "locations"
		},
		"fieldMap": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureContent": {
					"translations": {},
					"value": "formattedAddress"
				},
				"title": {
					"translations": {},
					"value": "label"
				}
			}
		},
		"icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"scale-balanced\",\"icon\":[640,512,[9878,\"balance-scale\"],\"f24e\",\"M384 32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L398.4 96c-5.2 25.8-22.9 47.1-46.4 57.3l0 294.7 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-384 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 0-294.7c-23.5-10.3-41.2-31.6-46.4-57.3L128 96c-17.7 0-32-14.3-32-32s14.3-32 32-32l128 0c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm55.6 288L584.4 320 512 195.8 439.6 320zM512 416c-62.9 0-115.2-34-126-78.9-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1-10.8 44.8-63.1 78.9-126 78.9zM126.8 195.8L54.4 320 199.3 320 126.8 195.8zM.9 337.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1-10.8 44.8-63.1 78.9-126 78.9S11.7 382 .9 337.1z\"]}",
				"name": "faBalanceScale"
			}
		},
		"index": 2,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "03"
		},
		"route": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "Locations"
		}
	},
	"Head": {
		"index": 3,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "01"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "مواقعنا",
				"en": "Our Locations",
				"en-GB": "Our Locations",
				"en-US": "Our Locations",
				"es": "Nuestras ubicaciones",
				"es-419": "Nuestras ubicaciones",
				"es-ES": "Nuestras ubicaciones",
				"he": "המיקומים שלנו",
				"it": "Le nostre sedi",
				"pl": "Nasze lokalizacje",
				"sw": "Maeneo Yetu",
				"tl": "Ang Aming mga Lokasyon",
				"vi": "Địa điểm của chúng tôi",
				"zh": "我们的位置"
			},
			"type": "TextInput",
			"value": "Our Locations"
		}
	},
	"Head For Location Page": {
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "locations"
		},
		"fieldMap": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"title": {
					"translations": {},
					"value": "label"
				}
			}
		},
		"index": 4,
		"pageOrder": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "01"
		}
	},
	"LocationPage": {
		"bgImage": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "لقطة جوية بانورامية مقرّبة لمبنى الكابيتول بولاية كاليفورنيا في سكرامنتو نهاراً. 4K",
						"en": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-GB": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-US": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"es": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-419": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-ES": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"he": "צילום אווירי מקרוב של בניין הקפיטול של מדינת קליפורניה בסקרמנטו בשעות היום. 4K",
						"it": "Ripresa aerea panoramica ravvicinata del Campidoglio dello Stato della California a Sacramento durante il giorno. 4K",
						"pl": "Zbliżenie na Kapitol Stanowy Kalifornii w Sacramento z lotu ptaka w ciągu dnia. 4K",
						"sw": "Picha ya karibu ya angani ya Capitol ya Jimbo la California huko Sacramento wakati wa mchana. 4K",
						"tl": "Malapitang kuha mula sa himpapawid ng California State Capitol sa Sacramento noong araw. 4K",
						"vi": "Cảnh quay cận cảnh từ trên cao tòa nhà Quốc hội bang California ở Sacramento vào ban ngày. Độ phân giải 4K.",
						"zh": "白天，从空中拍摄的加州州议会大厦（位于萨克拉门托）的特写镜头。4K"
					},
					"value": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Four%20locations%2FLocationPage%2FbgImage%2Fshutterstock_1092700045-first-frame.jpg?alt=media&token=aa040818-0912-4af9-9293-41e2bd769969",
				"formattedSize": "212.48 KB",
				"height": 500,
				"name": "shutterstock_1092700045-first-frame.jpg",
				"path": "uploads/our locations/LocationPage/bgImage/shutterstock_1092700045-first-frame.jpg",
				"query": "?as=run",
				"size": 217582,
				"type": "image/jpeg",
				"updated": "2026-01-10T06:53:52.285Z",
				"width": 1600
			}
		},
		"bgVideo": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "لقطة جوية بانورامية مقرّبة لمبنى الكابيتول بولاية كاليفورنيا في سكرامنتو نهاراً. 4K",
						"en": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-GB": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-US": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"es": "Primer plano aéreo panorámico del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-419": "Primer plano aéreo panorámico del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-ES": "Primer plano aéreo panorámico del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"he": "צילום אווירי מקרוב של בניין הקפיטול של מדינת קליפורניה בסקרמנטו בשעות היום. 4K",
						"it": "Ripresa aerea ravvicinata e panoramica del Campidoglio della California a Sacramento, di giorno. 4K",
						"pl": "Zbliżenie na Kapitol Stanowy Kalifornii w Sacramento z lotu ptaka w ciągu dnia. 4K",
						"sw": "Picha ya karibu ya angani ya Capitol ya Jimbo la California huko Sacramento wakati wa mchana. 4K",
						"tl": "Malapitang kuha mula sa himpapawid ng California State Capitol sa Sacramento noong araw. 4K",
						"vi": "Cảnh quay cận cảnh từ trên cao tòa nhà Quốc hội bang California ở Sacramento vào ban ngày. Độ phân giải 4K.",
						"zh": "白天，从空中拍摄的加州州议会大厦（位于萨克拉门托）的特写镜头。4K"
					},
					"value": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Four%20locations%2FLocationPage%2FbgVideo%2Fshutterstock_1092700045.mp4?alt=media&token=e76c9fcf-9af7-4818-9ef8-c5f95aa3843a",
				"formattedSize": "4.28 MB",
				"height": 500,
				"name": "shutterstock_1092700045.mp4",
				"path": "uploads/our locations/LocationPage/bgVideo/shutterstock_1092700045.mp4",
				"query": "?as=run",
				"size": 4491390,
				"type": "video/mp4",
				"updated": "2026-01-10T06:54:44.930Z",
				"width": 1600
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"bgImageClass": {
					"translations": {},
					"value": "opacity-20 grayscale w-full"
				},
				"contentClass": {
					"translations": {},
					"value": "py-2 sm:py-4"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "mx-auto text-center"
				},
				"featureTitleClass": {
					"translations": {},
					"value": "text-3xl"
				},
				"featureTitleContainerClass": {
					"translations": {},
					"value": "flex justify-center text-3xl"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 xl:grid-cols-2"
				},
				"imageClass": {
					"translations": {},
					"value": "w-24 mx-auto my-2 sm:my-4"
				},
				"titleClass": {
					"translations": {},
					"value": "hidden"
				}
			}
		},
		"defaultIcon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"scale-balanced\",\"icon\":[640,512,[9878,\"balance-scale\"],\"f24e\",\"M384 32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L398.4 96c-5.2 25.8-22.9 47.1-46.4 57.3l0 294.7 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-384 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 0-294.7c-23.5-10.3-41.2-31.6-46.4-57.3L128 96c-17.7 0-32-14.3-32-32s14.3-32 32-32l128 0c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm55.6 288L584.4 320 512 195.8 439.6 320zM512 416c-62.9 0-115.2-34-126-78.9-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1-10.8 44.8-63.1 78.9-126 78.9zM126.8 195.8L54.4 320 199.3 320 126.8 195.8zM.9 337.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1-10.8 44.8-63.1 78.9-126 78.9S11.7 382 .9 337.1z\"]}",
				"name": "faBalanceScale"
			}
		},
		"index": 5,
		"route": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "Locations"
		},
		"subtitle": {
			"permission": "Admin",
			"translations": {
				"ar": "مكتب المحامية آمبر بيلانتي",
				"en": "The Law Offices of Amber Bellante",
				"en-GB": "The Law Offices of Amber Bellante",
				"en-US": "The Law Offices of Amber Bellante",
				"es": "Las Oficinas Legales de Amber Bellante",
				"es-419": "Las Oficinas Legales de Amber Bellante",
				"es-ES": "Las Oficinas Legales de Amber Bellante",
				"he": "משרד עורכי הדין של אמבר בלנטה",
				"it": "Studio legale di Amber Bellante",
				"pl": "Kancelaria Adwokacka Amber Bellante",
				"sw": "Ofisi za Sheria za Amber Bellante",
				"tl": "Ang Mga Tanggapan ng Abogado ni Amber Bellante",
				"vi": "Văn phòng luật sư Amber Bellante",
				"zh": "安珀·贝兰特律师事务所"
			},
			"type": "TextInput",
			"value": "The Law Offices of Amber Bellante"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "مواقع المكاتب",
				"en": "Office Locations",
				"en-GB": "Office Locations",
				"en-US": "Office Locations",
				"es": "Ubicaciones de oficinas",
				"es-419": "Ubicaciones de oficinas",
				"es-ES": "Ubicaciones de oficinas",
				"he": "מיקומי משרדים",
				"it": "Posizioni degli uffici",
				"pl": "Lokalizacje biur",
				"sw": "Maeneo ya Ofisi",
				"tl": "Mga Lokasyon ng Opisina",
				"vi": "Địa điểm văn phòng",
				"zh": "办公地点"
			},
			"type": "TextInput",
			"value": "Office Locations"
		},
		"useMask": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "false"
		}
	},
	"Locations 01": {
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "py-2 sm:py-4"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "mx-auto text-center"
				},
				"featureTitleClass": {
					"translations": {},
					"value": "text-3xl"
				},
				"featureTitleContainerClass": {
					"translations": {},
					"value": "flex justify-center text-3xl"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 xl:grid-cols-2"
				},
				"imageClass": {
					"translations": {},
					"value": "w-24 mx-auto my-2 sm:my-4"
				},
				"titleClass": {
					"translations": {},
					"value": "hidden"
				}
			}
		},
		"defaultIcon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"scale-balanced\",\"icon\":[640,512,[9878,\"balance-scale\"],\"f24e\",\"M384 32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L398.4 96c-5.2 25.8-22.9 47.1-46.4 57.3l0 294.7 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-384 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 0-294.7c-23.5-10.3-41.2-31.6-46.4-57.3L128 96c-17.7 0-32-14.3-32-32s14.3-32 32-32l128 0c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm55.6 288L584.4 320 512 195.8 439.6 320zM512 416c-62.9 0-115.2-34-126-78.9-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1-10.8 44.8-63.1 78.9-126 78.9zM126.8 195.8L54.4 320 199.3 320 126.8 195.8zM.9 337.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1-10.8 44.8-63.1 78.9-126 78.9S11.7 382 .9 337.1z\"]}",
				"name": "faBalanceScale"
			}
		},
		"index": 6,
		"maxWidth": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "w-96"
		},
		"route": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "Locations"
		}
	},
	"PageBanner": {
		"bgImage": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "لقطة جوية بانورامية مقرّبة لمبنى الكابيتول بولاية كاليفورنيا في سكرامنتو نهاراً. 4K",
						"en": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-GB": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-US": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"es": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-419": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-ES": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"he": "צילום אווירי מקרוב של בניין הקפיטול של מדינת קליפורניה בסקרמנטו בשעות היום. 4K",
						"it": "Ripresa aerea panoramica ravvicinata del Campidoglio dello Stato della California a Sacramento durante il giorno. 4K",
						"pl": "Zbliżenie na Kapitol Stanowy Kalifornii w Sacramento z lotu ptaka w ciągu dnia. 4K",
						"sw": "Picha ya karibu ya angani ya Capitol ya Jimbo la California huko Sacramento wakati wa mchana. 4K",
						"tl": "Malapitang kuha mula sa himpapawid ng California State Capitol sa Sacramento noong araw. 4K",
						"vi": "Cảnh quay cận cảnh từ trên cao tòa nhà Quốc hội bang California ở Sacramento vào ban ngày. Độ phân giải 4K.",
						"zh": "白天，从空中拍摄的加州州议会大厦（位于萨克拉门托）的特写镜头。4K"
					},
					"value": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Four%20locations%2FPageBanner%2FbgImage%2Fshutterstock_1092700045-first-frame.jpg?alt=media&token=141ba255-14b3-41bc-b508-4dadd1021a3e",
				"formattedSize": "212.48 KB",
				"height": 500,
				"name": "shutterstock_1092700045-first-frame.jpg",
				"path": "uploads/our locations/PageBanner/bgImage/shutterstock_1092700045-first-frame.jpg",
				"query": "?as=run",
				"size": 217582,
				"type": "image/jpeg",
				"updated": "2025-12-30T23:24:28.882Z",
				"width": 1600
			}
		},
		"bgVideo": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "لقطة جوية بانورامية مقرّبة لمبنى الكابيتول بولاية كاليفورنيا في سكرامنتو نهاراً. 4K",
						"en": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-GB": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-US": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"es": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-419": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-ES": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"he": "צילום אווירי מקרוב של בניין הקפיטול של מדינת קליפורניה בסקרמנטו בשעות היום. 4K",
						"it": "Ripresa aerea panoramica ravvicinata del Campidoglio dello Stato della California a Sacramento durante il giorno. 4K",
						"pl": "Zbliżenie na Kapitol Stanowy Kalifornii w Sacramento z lotu ptaka w ciągu dnia. 4K",
						"sw": "Picha ya karibu ya angani ya Capitol ya Jimbo la California huko Sacramento wakati wa mchana. 4K",
						"tl": "Malapitang kuha mula sa himpapawid ng California State Capitol sa Sacramento noong araw. 4K",
						"vi": "Cảnh quay cận cảnh từ trên cao tòa nhà Quốc hội bang California ở Sacramento vào ban ngày. Độ phân giải 4K.",
						"zh": "白天，从空中拍摄的加州州议会大厦（位于萨克拉门托）的特写镜头。4K"
					},
					"value": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Four%20locations%2FPageBanner%2FbgVideo%2Fshutterstock_1092700045.mp4?alt=media&token=7aaeb48c-64aa-482f-a341-18e880bd5c2f",
				"formattedSize": "4.28 MB",
				"height": 500,
				"name": "shutterstock_1092700045.mp4",
				"path": "uploads/our locations/PageBanner/bgVideo/shutterstock_1092700045.mp4",
				"query": "?as=run",
				"size": 4491390,
				"type": "video/mp4",
				"updated": "2025-12-30T23:24:54.477Z",
				"width": 1600
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"bgImageClass": {
					"translations": {},
					"value": "opacity-20 grayscale w-full"
				}
			}
		},
		"index": 7,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "02"
		},
		"subtitle": {
			"permission": "Admin",
			"translations": {
				"ar": "مكتب المحامية آمبر بيلانتي",
				"en": "The Law Offices of Amber Bellante",
				"en-GB": "The Law Offices of Amber Bellante",
				"en-US": "The Law Offices of Amber Bellante",
				"es": "Las Oficinas Legales de Amber Bellante",
				"es-419": "Las Oficinas Legales de Amber Bellante",
				"es-ES": "Las Oficinas Legales de Amber Bellante",
				"he": "משרד עורכי הדין של אמבר בלנטה",
				"it": "Studio legale di Amber Bellante",
				"pl": "Kancelaria Adwokacka Amber Bellante",
				"sw": "Ofisi za Sheria za Amber Bellante",
				"tl": "Ang Mga Tanggapan ng Abogado ni Amber Bellante",
				"vi": "Văn phòng luật sư Amber Bellante",
				"zh": "安珀·贝兰特律师事务所"
			},
			"type": "TextInput",
			"value": "The Law Offices of Amber Bellante"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "مواقع المكاتب",
				"en": "Office Locations",
				"en-GB": "Office Locations",
				"en-US": "Office Locations",
				"es": "Ubicaciones de oficinas",
				"es-419": "Ubicaciones de oficinas",
				"es-ES": "Ubicaciones de oficinas",
				"he": "מיקומי משרדים",
				"it": "Posizioni degli uffici",
				"pl": "Lokalizacje biur",
				"sw": "Maeneo ya Ofisi",
				"tl": "Mga Lokasyon ng Opisina",
				"vi": "Địa điểm văn phòng",
				"zh": "办公地点"
			},
			"type": "TextInput",
			"value": "Office Locations"
		},
		"useMask": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "false"
		}
	},
	"PageBanner For Location Page": {
		"bgImage": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "لقطة جوية بانورامية مقرّبة لمبنى الكابيتول بولاية كاليفورنيا في سكرامنتو نهاراً. 4K",
						"en": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-GB": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-US": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"es": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-419": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-ES": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"he": "צילום אווירי מקרוב של בניין הקפיטול של מדינת קליפורניה בסקרמנטו בשעות היום. 4K",
						"it": "Ripresa aerea panoramica ravvicinata del Campidoglio dello Stato della California a Sacramento durante il giorno. 4K",
						"pl": "Zbliżenie na Kapitol Stanowy Kalifornii w Sacramento z lotu ptaka w ciągu dnia. 4K",
						"sw": "Picha ya karibu ya angani ya Capitol ya Jimbo la California huko Sacramento wakati wa mchana. 4K",
						"tl": "Malapitang kuha mula sa himpapawid ng California State Capitol sa Sacramento noong araw. 4K",
						"vi": "Cảnh quay cận cảnh từ trên cao tòa nhà Quốc hội bang California ở Sacramento vào ban ngày. Độ phân giải 4K.",
						"zh": "白天，从空中拍摄的加州州议会大厦（位于萨克拉门托）的特写镜头。4K"
					},
					"value": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Four%20locations%2FPageBanner%20For%20Location%20Page%2FbgImage%2Fshutterstock_1092700045-first-frame.jpg?alt=media&token=4c88806b-1648-47dd-9433-b1d064e57aa0",
				"formattedSize": "212.48 KB",
				"height": 500,
				"name": "shutterstock_1092700045-first-frame.jpg",
				"path": "uploads/our locations/PageBanner For Location Page/bgImage/shutterstock_1092700045-first-frame.jpg",
				"query": "?as=run",
				"size": 217582,
				"type": "image/jpeg",
				"updated": "2026-02-27T06:43:02.663Z",
				"width": 1600
			}
		},
		"bgVideo": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "لقطة جوية بانورامية مقرّبة لمبنى الكابيتول بولاية كاليفورنيا في سكرامنتو نهاراً. 4K",
						"en": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-GB": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-US": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"es": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-419": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-ES": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"he": "צילום אווירי מקרוב של בניין הקפיטול של מדינת קליפורניה בסקרמנטו בשעות היום. 4K",
						"it": "Ripresa aerea panoramica ravvicinata del Campidoglio dello Stato della California a Sacramento durante il giorno. 4K",
						"pl": "Zbliżenie na Kapitol Stanowy Kalifornii w Sacramento z lotu ptaka w ciągu dnia. 4K",
						"sw": "Picha ya karibu ya angani ya Capitol ya Jimbo la California huko Sacramento wakati wa mchana. 4K",
						"tl": "Malapitang kuha mula sa himpapawid ng California State Capitol sa Sacramento noong araw. 4K",
						"vi": "Cảnh quay cận cảnh từ trên cao tòa nhà Quốc hội bang California ở Sacramento vào ban ngày. Độ phân giải 4K.",
						"zh": "白天，从空中拍摄的加州州议会大厦（位于萨克拉门托）的特写镜头。4K"
					},
					"value": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Four%20locations%2FPageBanner%20For%20Location%20Page%2FbgVideo%2Fshutterstock_1092700045.mp4?alt=media&token=0d3649cd-eb59-4a56-ac71-e1e2257737b0",
				"formattedSize": "4.28 MB",
				"height": 500,
				"name": "shutterstock_1092700045.mp4",
				"path": "uploads/our locations/PageBanner For Location Page/bgVideo/shutterstock_1092700045.mp4",
				"query": "?as=run",
				"size": 4491390,
				"type": "video/mp4",
				"updated": "2026-02-27T07:03:53.877Z",
				"width": 1600
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"bgImageClass": {
					"translations": {},
					"value": "opacity-20 grayscale"
				}
			}
		},
		"docsCollection": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "locations"
		},
		"fieldMap": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"title": {
					"translations": {},
					"value": "label"
				}
			}
		},
		"index": 8,
		"pageOrder": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "02"
		},
		"subtitle": {
			"permission": "Admin",
			"translations": {
				"ar": "مكتب المحامية آمبر بيلانتي",
				"en": "The Law Offices of Amber Bellante",
				"en-GB": "The Law Offices of Amber Bellante",
				"en-US": "The Law Offices of Amber Bellante",
				"es": "El bufete de abogados de Amber Bellante",
				"es-419": "El bufete de abogados de Amber Bellante",
				"es-ES": "El bufete de abogados de Amber Bellante",
				"he": "משרד עורכי הדין של אמבר בלנטה",
				"it": "Lo studio legale di Amber Bellante",
				"pl": "Kancelaria Adwokacka Amber Bellante",
				"sw": "Ofisi za Sheria za Amber Bellante",
				"tl": "Ang Mga Tanggapan ng Abogado ni Amber Bellante",
				"vi": "Văn phòng luật sư Amber Bellante",
				"zh": "安珀·贝兰特律师事务所"
			},
			"type": "TextInput",
			"value": "The Law Offices of Amber Bellante"
		},
		"useMask": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "false"
		}
	}
}